import { render, staticRenderFns } from "./SalesLeadNotice.vue?vue&type=template&id=9c4a4d5c&scoped=true&"
import script from "./SalesLeadNotice.vue?vue&type=script&lang=js&"
export * from "./SalesLeadNotice.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeadNotice.vue?vue&type=style&index=0&id=9c4a4d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4a4d5c",
  null
  
)

export default component.exports